// eslint-disable-next-line import/prefer-default-export
export const LIGNE_REGROUPEMENT_PERSONNALISEE = {
  errors: {
    leastOneLine: 'Il faut selectionner au moins une ligne',
    ligneCommandePartiellement: 'Dans un devis commandé partiellement, seules les lignes de ventes en dessous des lignes de ventes déjà commandées peuvent être regroupées',
    typeLine: 'On ne peut que regrouper des lignes de ventes',
    alreadyGroup: 'Une des lignes fait déjà partie d\'un le groupe de produit',
    sameTva: 'Les lignes de ventes doivent avoir le même taux de TVA',
    order: 'Les lignes de ventes doivent se suivre',
    commande: {
      echeancierManuel: 'Au moins une des lignes est dans un échéancier modifié manuellement',
      echeancierRegroupe: 'Au moins une des lignes fait partie d\'un échéancier regroupé',
      bill: 'Au moins une des lignes a été facturée',
    },
  },
  popUpInformation: {
    title: 'Information sur le regroupement',
    subTitle: '{nbProduit} produit(s) sélectionné(s) - Total de {nbEcran} écran(s) - Total de {nbDiffusion} diffusion(s)',
    subTitle2: '{nbProduit} produit(s) sélectionné(s)',
    produit: 'Produit',
    libelle: 'Libellé',
    nbEcran: 'Nb écrans',
    nbDiffusion: 'Nb diffusion',
  },
  popup: {
    unableToCreate: 'Impossible de créer le groupe de produit',
    unableToViewInformation: 'Impossible de voir les informations du groupe de produit',
  },
  erreur: {
    atLeastOneSelected: 'Il faut selectionner au moins une ligne avec un produit',
    produitWhithProductId: 'Il faut selectionner une ligne de commande avec un produit',
  },
  planning: 'Créer un groupe de produit',
  dissociate: 'Dissocier',
  infoRegroupement: 'Information sur le regroupement',
};
